export enum CompareType {
  Alphabetical = 'alphabetical',
  Numerical = 'numerical'
}
